module.exports = __webpack_public_path__ + "img/29.127fe58e.png";